<div class="weekday-select mt-2.5">
  <label
    class="weekday-select--weekday"
    [ngClass]="{ 'weekday-checked': day.control.value }"
    *ngFor="let day of weekdays"
  >
    {{ day.name }}
    <input
      type="checkbox"
      class="weekday-checkbox"
      [formControl]="day.control"
      [value]="day.id"
    />
  </label>
</div>
